enum StatusEnum {
    Active = 'ACTIVE',
    GracePeriod = 'GRACE_PERIOD',
    Repaid = 'REPAID',
}

export default StatusEnum;
